import type { FetchRetryOptions } from '@/src/utils/fetchWithRetry'

export enum StrapiContentType {
  // Single types
  APP = 'app',
  SEO = 'seo',
  MAINTENANCE = 'maintenance',

  // Collection types
  PAGES = 'pages',
  PAGES_COLLECTIONS = 'pages-collections',
  APP_CONTENTS = 'app-contents',
  CASE_STUDIES = 'case-studies',
  COUNSELLING_PAGES = 'counselling-pages',
  MATCHING_TEST = 'matching-test',
  CUSTOM_MENUS = 'custom-menus',
  REDIRECTS = 'redirects',
}

export enum StrapiContentModel {
  // Single types
  APP = 'app',
  SEO = 'seo',
  MAINTENANCE = 'maintenance',
  MATCHING_TEST = 'matching-test',

  // Collection types
  PAGES_COLLECTION = 'pages-collection',
  APP_CONTENT = 'app-content',
  CUSTOM_MENU = 'custom-menu',
  COUNSELLING_PAGE = 'counselling-page',
}

export enum StrapiPagesCollectionCategory {
  PUBLIC = 'public',
  BUSINESS = 'business',
}

export enum StrapiCustomMenu {
  MAIN = 'main-menu',
  OTHER = 'other-menu',
  THERAPIST = 'therapist-menu',
  CLINIC = 'clinic-menu',

  BUSINESS_MAIN = 'business-main-menu',
  BUSINESS_SOLUTION = 'business-solution-menu',
  BUSINESS_HOW_IT_WORKS = 'business-how-it-works-menu',
  BUSINESS_BOTTOM = 'business-bottom-menu',

  SIDEBAR = 'sidebar',
}

export enum StrapiMenuSpecialFunction {
  NONE = 'none',
  THERAPISTS = 'therapists',
  OTHER = 'other',
  SERVICES = 'services',
  SPECIALIZATIONS = 'specializations',
  BUSINESS_HOW = 'business-how',
  BUSINESS_SOLUTION = 'business-solution',
  CLINIC = 'clinic',
  CLINIC_LOCATION = 'clinic-location',
}

const STRAPI_TRANSIENT_STATUSES = [502, 503, 504]

// A static build prerenders hundreds of pages; one Strapi blip (502, dropped connection) would otherwise fail it all
export const strapiFetchRetryOptions: FetchRetryOptions = {
  delaysMs: [1000, 3000],
  shouldRetryResponse: (res) => STRAPI_TRANSIENT_STATUSES.includes(res.status),
}
